/* @flow */
import React from 'react';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import { withDocumentTitle } from 'lib/documentTitle';

import './styles/NotFoundPage.scss';

class NotFoundPage extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  goBack = () => {
    if (!this.context.router) {
      // We aren't in a Route Handler, so use browser API to relocate
      window.location.replace('/classes');
      return;
    }

    if (window.history.length > 1) {
      this.context.router.goBack();
    } else {
      this.context.router.replace('/');
    }
  }

  render() {
    return (
      <div className="NotFoundPage">
        <div className="NotFoundPage-content">
          <Image
            className="NotFoundPage-image"
            src={require('assets/images/emoji-grin.svg')}
            alt="This is embarrassing"
          />

          <div className="NotFoundPage-title">Uh oh! Something went wrong.</div>
          <div className="NotFoundPage-subtext">
            <Link
              onClick={this.goBack}
              className="NotFoundPage-link"
              eventElementName="NotFoundPage-link">
              Go back
            </Link>
            <span> or </span>
            <ModalTrigger modal={<SupportDialog />}>
              <Link className="NotFoundPage-link" eventElementName="NotFoundPage-link">
                get help
              </Link>
            </ModalTrigger>.
          </div>
        </div>
      </div>
    );
  }
}

export default withDocumentTitle('Not found', NotFoundPage);



// WEBPACK FOOTER //
// ./src/app/components/NotFoundPage.jsx